import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store";
import NoteForm from "@/components/note/NoteForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditNotePage',
  setup(__props) {

const store = useStore();
const route = useRoute();

onMounted(() => {
  if (route.params.id) {
    store.dispatch(Actions.GetNote, route.params.id);
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(store).state.note)
    ? (_openBlock(), _createBlock(NoteForm, { key: 0 }))
    : _createCommentVNode("", true)
}
}

})